export default __webpack_public_path__ + "static/media/testimonial-1.c22f3cdc.png";